module.exports = __webpack_public_path__ + "media/images/web/favicon/android-icon-96x96-26d9b207cf26a28166271a23ff107ddd.png";